<template>
    <Form as="" :validation-schema="schema" v-slot="{ meta, handleSubmit }">
        <bs5-base-modal :title="$t('distributors.editTitle')" :visible="visible" @close="closeModal">
            <template v-slot:default>
                <form novalidate @submit.prevent="handleSubmit($event, updateDistributor)">
                    <bs5-form-field id="editDistributorName" name="name" :label="$t('common.name')"
                        v-model="distributor.name" />
                    <bs5-form-field id="editDistributorDescription" name="description"
                        :label="$t('common.description')" v-model="distributor.description" />
                    <button type="submit" class="d-none" tabindex="-1" aria-hidden="true"></button>
                </form>
            </template>

            <template v-slot:footer>
                <bs5-cancel-button @click="closeModal" />
                <bs5-save-button :loading="saving" :disabled="!meta.valid"
                    @click="handleSubmit($event, updateDistributor)">
                    <i class="bi bi-check2"></i>{{ $t("common.save") }}
                </bs5-save-button>
            </template>
        </bs5-base-modal>
    </Form>
</template>

<script lang="ts">
import { t } from "@/helpers/i18n";
import { defineComponent, ref } from "vue";
import { Form } from "vee-validate";
import * as yup from "yup";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import { showToast } from "@/utils/toast";
import { nameMaxLength, optionalText, requiredText } from "@/utils/validation";

export default defineComponent({
    name: "EditDistributorModal",
    components: { Form },
    props: {
        visible: { type: Boolean, required: true },
        distributorId: { type: String, required: true },
    },
    emits: ["close", "distributor-updated"],
    data() {
        return {
            distributor: ref<Distributor>({ id: "", name: "", description: "" }),
            saving: ref(false),
        };
    },
    computed: {
        schema() {
            return yup.object({
                name: requiredText(nameMaxLength),
                // API zwraca opis jako null, gdy dystrybutor go nie ma (DistributorDTO.Description to string?)
                description: optionalText().nullable(),
            });
        },
    },
    watch: {
        distributorId: {
            immediate: true,
            handler(newId) {
                if (newId) {
                    this.fetchDistributor();
                }
            },
        },
    },
    methods: {
        async fetchDistributor() {
            try {
                this.distributor = await distributorService.getDistributorById(this.distributorId);
            } catch (error) {
                console.error("Error fetching distributor:", error);
            }
        },
        async updateDistributor() {
            this.saving = true;
            try {
                await distributorService.updateDistributor(this.distributor.id as string, this.distributor);
                this.$emit("distributor-updated");
                this.closeModal();
                showToast(t("distributors.updated"), "success");
            } catch (error) {
                showToast(t("distributors.updateFailed"), "error");
                console.error("Error updating distributor:", error);
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
